import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';
import { useSpring, animated } from 'react-spring/web.cjs'; // web.cjs is required for IE 11 support
import styled, { css } from 'styled-components';

const Caption = styled.div`
  ${({ theme }) => css`
    h5 {
      margin-left: 20px;
      color: ${theme.colors.gray400};
      width: 100%;
      text-align: center;
      margin: 0px;
      font-size: x-small;
      margin-top: 5px;
    }
  `}
`;

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    borderRadius: 6,
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0px 8px 12px #0000003D;',
    padding: theme.spacing(3),
  },
}));

const Fade = React.forwardRef((props, ref) => {
  const { in: open, children, onEnter, onExited, ...other } = props;
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter();
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited();
      }
    },
  });

  return (
    <animated.div ref={ref} style={style} {...other}>
      {children}
    </animated.div>
  );
});

const CustomModal = (props) => {
  const classes = useStyles();
  const { title, subTitle, open, handleClose, style, className, fadeClass, caption, subCaption } =
    props;
  return (
    <div>
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={[classes.modal, className].join(' ')}
        open={open}
        onClose={() => {
          if (handleClose) {
            handleClose(true);
          }
        }}
        id="modal-personalizado"
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        style={props.style}
      >
        <Fade in={open}>
          <div
            className={[classes.paper, fadeClass].join(' ')}
            id="contenedor-de-fade"
            style={{ ...style }}
          >
            {title && <h2 id="spring-modal-title">{title}</h2>}
            {subTitle && <h3>{subTitle}</h3>}
            {props.children}
          </div>

          {caption && (
            <Caption id="caption" style={{ ...style }}>
              {caption && <h5>{caption}</h5>}
              {subCaption && <h5>{subCaption}</h5>}
            </Caption>
          )}
        </Fade>
      </Modal>
    </div>
  );
};

export default CustomModal;
